<template>
  <div>
    <!-- 导航 -->
    <div>
      <van-nvabar left-text="返回"
                  right-text="全部"
                  left-arrow
                  @click-left="onClickLeft"
                  @click-right="onClickRight"
                  title="产品列表">
      </van-nvabar>
    </div>
    <!-- 套餐弹出层 -->
    <van-popup v-model="showPackage"
               position="top"
               :style="{ height: '50%' }">
      <div class="mobileTitle">
        套餐列表:
      </div>
      <div class="package_select_item"
           @click="selectPackagePop(index)"
           v-for="item,index in skus"
           :key="index">【{{index+1}}】{{item.sku_name}}</div>
    </van-popup>
    <!-- 产品介绍 -->
    <div>
      <van-collapse v-model="activeNames"
                    @change="changeActiveNames">
        <van-collapse-item name="1">
          <template #title>
            <div>{{spu_name}}| <span v-for="item,index in spu_dest"
                    :key="index">{{item}}</span></div>
          </template>
          <div style="margin:10px 0">
            <van-icon name="newspaper-o"
                      @click="cteateImageSpu(spu_id)"
                      size="20px" />
            <div :id="'booking_confirm_image' + spu_id"
                 class="edito-save-right"
                 v-html="spu_detail"></div>
          </div>
        </van-collapse-item>
      </van-collapse>
    </div>
    <div style="background:#ff5421;height: 2px;margin-top:10px"></div>
    <!-- 标签 -->
    <van-tabs v-model="activeName"
              :animated="false"
              @scroll="scrollPage"
              scrollspy
              sticky>
      <van-tab v-for="item,index in skus"
               :key="index"
               :title="'【'+(index+1)+'】'+item.sku_name">
        <!-- 生成套餐介绍 图片 -->
        <div :id="'booking_confirm_image' + item.sku_id"
             style="background:#f7f4f4;padding-bottom:10px;padding-top:10px">
          <!-- 套餐介绍 -->
          <div class="mobileCardTop">
            <!-- 内容展示 -->
            <div style="display:flex;justify-content:space-between"
                 @click="showPriceButton">

              <div>【{{index+1}}】{{item.sku_name}}</div>

              <div style="display:flex">
                <div>
                  状态：<span style="color:green">{{item.sku_status}}</span>
                </div>
                <div style="text-align:center; color: #ff5421;padding-left:5px">
                  <van-icon name="newspaper-o"
                            @click.stop="cteateImage(item)"
                            size="16px" />
                </div>
              </div>
            </div>
            <!-- 价格 -->
            <div v-if="showPrice"
                 style="background-color:#ff5421;border-radius:10px;padding:10px;margin-top:10px">
              <div style="color:#FFF">原价：{{ (item.price_range / 100).toFixed(2) }}</div>
              <div style="color:#FFF">售价：{{ (item.sell_price_range / 100).toFixed(2) }}</div>
              <div style="color:#FFF">底价：{{ (item.net_price_range / 100).toFixed(2) }}</div>
            </div>
            <!-- 行程说明 -->
            <div>
              <div class="mobileTitle">套餐介绍:</div>
              <div class="edito-save-right"
                   @click="pastContent($event)"
                   v-html="item.sku_info"></div>
            </div>
            <!-- 费用包含 -->
            <div @click="pastContent($event)">
              <div class="mobileTitle">费用包含:</div>
              <div class="edito-save-right"
                   v-html="item.fee_include"></div>
            </div>
            <!-- 预订须知 -->
            <div @click="pastContent($event)">
              <div class="mobileTitle">预订须知:</div>
              <div class="edito-save-right"
                   v-html="item.confirm_info"></div>
            </div>

          </div>
          <!-- 退改原则 -->
          <div class="mobileCardBottom"
               style="margin-bottom:10px"
               @click="pastContent($event)">
            <div class="mobileTitle">退改原则:</div>
            <div class="edito-save-right"
                 v-html="item.refund_info"></div>
          </div>
        </div>
      </van-tab>
    </van-tabs>
    <div style="height:10px"></div>
    <van-divider content-position="left"
                 :style="{ fontSize:'10px', color: 'grey', borderColor: 'grey', padding: '0 16px' }">到头了，别翻了</van-divider>
    <div style="height:10px"></div>
    <!-- 回到顶部 -->
    <el-backtop></el-backtop>
  </div>
</template>

<script>
import { Tab, Tabs } from 'vant'
import { Divider } from 'vant'
import { NavBar } from 'vant'
import { Popup } from 'vant'
import { Notify } from 'vant'
import { Collapse, CollapseItem } from 'vant'
import { Icon } from 'vant'
import html2canvas from 'html2canvas'

export default {
  name: 'm_product_introduce',
  components: {
    'van-tab': Tab,
    'van-tabs': Tabs,
    'van-divider': Divider,
    'van-nvabar': NavBar,
    'van-popup': Popup,
    'van-collapse': Collapse,
    'van-collapse-item': CollapseItem,
    'van-icon': Icon,
  },
  data() {
    return {
      activeNames: [],
      skus: [],
      showPackage: false,
      activeName: '',
      operator_info: {},
      showPrice: true,
      //
      spu_name: '',
      spu_dest: '',
      spu_id: '',
      spu_detail: '',
    }
  },

  created() {
    this.getProductINtorduce(this.$route.query.spu_id)
  },
  methods: {
    cteateImageSpu(spu_id) {
      let element_id = 'booking_confirm_image' + spu_id
      let options = {
        allowTaint: false,
        backgroudColor: null,
        useCORS: true,
        // 下面解决当页面滚动之后生成图片出现白边问题
        // height: document.getElementById('booking_confirm_image').offsetHeight,
        // width: document.getElementById('booking_confirm_image').offsetWidth,
        height: document.getElementById(element_id).scrollHeight,
        windowHeight: document.getElementById(element_id).scrollHeight,
        // windowWidth: document.body.scrollWidth,
        windowHeight: document.body.scrollHeight,
        scrollX: 0,
        scrollY: -window.pageYOffset,
        // x: 0,
        // y: 0,
        scale: 4, //
      }
      //
      //
      html2canvas(document.getElementById(element_id), options).then(
        (canvas) => {
          let image = canvas.toDataURL('image/png')
          // 下载图片
          this.fileDownload(image)
        }
      )
    },
    cteateImage(item) {
      let element_id = 'booking_confirm_image' + item.sku_id

      // 获取元素到窗口的高度
      console.log(document.getElementById(element_id).getBoundingClientRect())

      // 滚动的高度
      // document.body.scrollHeight body可滚动高度
      let options = {
        allowTaint: false,
        backgroudColor: null,
        useCORS: true,

        // 画布高度/宽度：
        // offsetHeight == scrollHeight
        // height: document.getElementById(element_id).offsetHeight,
        width: document.getElementById(element_id).offsetWidth,
        height: document.getElementById(element_id).offsetHeight,

        // 渲染元素时使用窗口高度
        // windowHeight: document.getElementById(element_id).scrollHeight,
        // windowWidth: document.body.scrollWidth,
        // windowHeight: document.body.scrollHeight,

        // 使用y的滚动位置 positinon:fixed 时使用
        // scrollX: 0,
        // scrollY: 0,

        // 裁剪画布图片y轴坐标

        // x: 0,
        y:
          window.pageYOffset +
          document.getElementById(element_id).getBoundingClientRect().y,

        scale: 4, //
      }
      //
      //
      html2canvas(document.getElementById(element_id), options).then(
        (canvas) => {
          let image = canvas.toDataURL('image/png')
          // 下载图片
          this.fileDownload(image)
        }
      )
    },
    changeActiveNames(item) {
      console.log(item)
    },
    scrollPage(event) {},
    onClickRight() {
      this.showPackage = true
    },
    onClickLeft() {
      this.$router.push({ path: `/m_product_list` })
    },
    showPriceButton() {
      this.showPrice = !this.showPrice
    },
    // 复制文本信息pastContent
    pastContent(event) {
      // console.log(event.target.outerText);
      this.$copyText(event.target.outerText)
        .then((res) => {
          Notify({ type: 'primary', message: '已复制内容', duration: 1000 })
        })
        .catch((res) => {
          console.log('出错错了')
        })
    },
    selectPackagePop(index) {
      this.showPackage = false
      this.activeName = index
    },
    fileDownload(downloadUrl) {
      let aLink = document.createElement('a')
      aLink.style.display = 'none'
      aLink.href = downloadUrl
      aLink.download = '套餐介绍.png'
      // 触发点击-然后移除
      document.body.appendChild(aLink)
      aLink.click()
      document.body.removeChild(aLink)
    },
    // 获取产品 信息
    getProductINtorduce(spu_id) {
      // console.log(this.$route.params.id);路由参数
      // 发送请求
      this.$http.get(`/product/get_product?spu_id=${spu_id}`).then((res) => {
        console.log(res)
        const { data, errmsg, errno } = res.data
        // 产品信息的对应
        this.spu_name = data.spu_name
        this.spu_id = data.id
        this.spu_image = data.spu_image
        this.out_spu_id = data.out_spu_id
        this.spu_dest = data.dest
        this.spu_dest_id = data.spu_dest_id
        this.spu_dest_pid = data.spu_dest_pid
        this.spu_detail = data.spu_detail
        this.stock_type = data.stock_type
        // 操作上的对应,如果没有操作商的信息
        if (data.operator_info == null) {
          this.operator_info_has = true
          this.operator_avatar = ''
        } else {
          this.operator_info_has = false
          this.operator_avatar = data.operator_info.operator_avatar
          this.operator_url = data.operator_info.operator_avatar
          this.operator_info.operator_name = data.operator_info.operator_name
          this.operator_info.operator_mobile =
            data.operator_info.operator_mobile
          this.operator_info.operator_loc_name =
            data.operator_info.operator_loc_name
          this.operator_info.operator_dest = data.operator_info.operator_dest
          this.operator_info.operator_address =
            data.operator_info.operator_address
          this.operator_info.operator_manager =
            data.operator_info.operator_manager
          this.operator_info.operator_intro = data.operator_info.operator_intro
        }
        // 套餐的对应
        this.skus = data.skus
        // console.log(this.skus);
      })
    },
  },
}
</script>

<style>
html body {
  background: #f7f4f4;
  /* background: red; */
}
.mobileTitle {
  border-left: 5px solid #ff5420;
  padding: 0 5px;
}
.edito-save-right {
  margin-top: 5px;
  padding: 0px 10px;
  white-space: pre-wrap;
}
.edito-save-right img {
  width: 100%;
  border-radius: 10px;
  margin: 5px 0;
}

.package_select_item {
  padding: 10px;
  margin: 5px;
  border: 1px solid rgb(179, 184, 189);
  border-radius: 10px;
}
</style>